import { Application } from '@hotwired/stimulus'

import PackageSelectController from './package_select_controller'
const application = Application.start()
import QuantityController from './quantity_controller'
application.register('package-select', PackageSelectController)
application.register('quantity', QuantityController)

